export default function MyopenJesongChat(c,g) {
  openJesongChatByGroup(c,g)
}



//////////////////
// WEBPACK FOOTER
// ./config/chat.js
// module id = null
// module chunks = 